import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=9541cf74&scoped=true&"
import script from "./OrderEdit.vue?vue&type=script&lang=js&"
export * from "./OrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=9541cf74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9541cf74",
  null
  
)

export default component.exports